module.exports = __webpack_public_path__ + "static/media/hs4.6cc4e203.jpg";